import { api } from "@/lib/api";
import {
  payerParties,
  RECIPIENT_KIND,
  type PaymentDateRange,
  type PaymentRecipientType,
  type PaymentScope,
  type StripePaymentMethodType,
} from "@/services/stripe-subs-payments.service";

export interface PayWithSavedMethodPayload {
  amount: number;
  recipientType: PaymentRecipientType;
  recipientId: string;
  paymentScope?: PaymentScope;
  dateRange?: PaymentDateRange;
}

export interface PayWithSavedMethodResponse {
  paymentIntentId: string;
  status: string;
  requiresAction: boolean;
  clientSecret: string | null;
  amount: number;
  currency: string;
  applicationFeeAmount: number;
  netTransferAmount: number;
  paymentMethodType: StripePaymentMethodType;
  paymentAttemptId: string;
}

export async function payWithSavedMethod(payload: PayWithSavedMethodPayload): Promise<PayWithSavedMethodResponse> {
  const paid = await api.paymentDues.payWithSavedMethod(RECIPIENT_KIND[payload.recipientType], payload.recipientId, {
    ...payerParties(payload.dateRange, payload.paymentScope),
    amountCents: payload.amount,
  });
  return {
    paymentIntentId: paid.paymentIntent,
    status: paid.status,
    requiresAction: paid.requiresAction,
    clientSecret: paid.clientSecret,
    amount: paid.amountCents,
    currency: paid.currency,
    applicationFeeAmount: paid.applicationFeeCents,
    netTransferAmount: paid.netTransferCents,
    paymentMethodType: paid.paymentMethodType,
    paymentAttemptId: paid.attempt,
  };
}
